import { render, staticRenderFns } from "./create_update.vue?vue&type=template&id=87f764f4&scoped=true&"
import script from "./create_update.vue?vue&type=script&lang=js&"
export * from "./create_update.vue?vue&type=script&lang=js&"
import style0 from "./create_update.vue?vue&type=style&index=0&id=87f764f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f764f4",
  null
  
)

export default component.exports